export default [{
  path: '/selectMatch',
  component: () => import('@/layouts/Router'),
  children: [
    // 赛事中心 - 选择比赛 作为新的默认入口
    {
      path: '',
      component: () => import('@/views/contest/selectMatch' /* webpackChunkName: "selectMatch" */),
      name: 'selectMatch',
      meta: {
        layout: 'dashboard',
        needLogin: true
      }
    },
    // 赛事中心 - 选择比赛的下一级入口
    {
      path: 'contest',
      component: () => import('@/views/contest' /* webpackChunkName: "contest" */),
      name: 'contest',
      meta: {
        layout: 'dashboard',
        needLogin: true
      }
    },
    // 操作日志
    {
      path: 'operationLog',
      component: () => import('@/views/contest/operationLog' /* webpackChunkName: "operationLog" */),
      name: 'operationLog',
      meta: {
        layout: 'dashboard',
        needLogin: true
      }
    },
    // 批量报名
    {
      path: 'batchSign',
      component: () => import('@/views/contest/batchSign' /* webpackChunkName: "batchSign" */),
      name: 'batchSign',
      meta: {
        layout: 'dashboard',
        needLogin: true
      }
    },
    {
      path: '*',
      redirect: '/selectMatch'
    }
  ]
}]
